import React from 'react';
import Modal from '../../commons/modal/modal';

import styles from './deleteConfirmationModal.scss';

type Props = {
  showModal: boolean,
  closeModal: Function,
  title: string
};

class DeleteVehicleConfirmationModal extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal
        showModal={this.props.showModal}
        title={this.props.title}
        closeModal={this.props.closeModal}
      >
        <div className={styles.modalContainer}>
          <div className={styles.modalContent}>
            <div className={styles.confirmationText}>
              Are you sure you want to delete this vehicle?
            </div>
            <div className={styles.buttonsContainer}>
              <div
                className={`${styles.actionButton} ${styles.cancelBtn}`}
                onClick={this.props.closeModal}
              >
                Cancel
              </div>
              <div
                className={`${styles.actionButton} ${styles.confirmBtn}`}
                onClick={() => this.props.deleteVehicle(this.props.vehicledId)}
              >
                Confirm
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default DeleteVehicleConfirmationModal;
